module.exports = __webpack_public_path__ + "static/media/arrow-left.5f9b21b9.svg";